import { render, staticRenderFns } from "./UserDates.vue?vue&type=template&id=8064ace6&scoped=true&"
import script from "./UserDates.vue?vue&type=script&lang=js&"
export * from "./UserDates.vue?vue&type=script&lang=js&"
import style0 from "./UserDates.vue?vue&type=style&index=0&id=8064ace6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8064ace6",
  null
  
)

export default component.exports